<template>
    <div class="addEmployeeCSV">
        <div class="c-common-space jobs-gridview c-responsive-fixwidth o-overflow-visible">
            <div class="row">
                <div v-loading="loading" class="col-sm-9 col-md-9">
                    <div class="grids c-common-box-shadow c-radius3 c-bg-white o-super-signin-area">
                        <div class="head">
                            <h3 class="o-super-title">Add Employee CSV import:</h3>
                        </div>
                        <div class="body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="o-accordion-subtext o-rowtable-text form-inline o-rowtable-text">
                                        <h6 class="bold-text"><strong>* Please Read Before Upload</strong></h6>
                                        <p class="ps1">To prepare your CSV for the import, you must ensure the following:</p>
                                        <ul class="skill-details">
                                            <li>1. The CSV must not contain blank rows which separate valid records.</li>
                                            <li>2. The first row must consist of the field names related to the data</li>
                                            <li>3. Acceptable format for upload: <strong>ods,xlsx,xls.csv</strong></li>
                                        </ul>
                                    </div>
                                    <div class="o-accordion-subtext o-rowtable-text form-inline o-rowtable-text">
                                        <div class="table-responsive o-no-margin-bottom">
                                            <table class="table table-bordered o-demo-table o-no-margin-bottom">
                                            <thead>
                                                <tr>
                                                <th>first_name</th>
                                                <th>last_name</th>
                                                <th>email</th>
                                                    <th>address</th>
                                                    <th>state</th>
                                                    <th>city</th>
                                                    <th>country</th>
                                                    <th>zipcode</th>
                                                    <th>phone</th>
                                                    <th> is member</th>
                                                    <th>seniority</th>
                                                    <th>date of hire</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                <td>abc</td>
                                                <td>xyz</td>
                                                <td>abc@xyz.com</td>
                                                <td>Lorem Ipsum</td>
                                                <td>Lorem</td>
                                                <td>Lorem</td>
                                                <td>Lorem</td>
                                                <td>Lorem</td>
                                                <td>Lorem</td>
                                                <td>1</td>
                                                <td>12</td>
                                                <td>Lorem</td>
                                                </tr>
                                                <tr>
                                                <td>abc</td>
                                                <td>xyz</td>
                                                <td>abc@xyz.com</td>
                                                <td>Lorem Ipsum</td>
                                                <td>Lorem</td>
                                                <td>Lorem</td>
                                                <td>Lorem</td>
                                                <td>Lorem</td>
                                                <td>Lorem</td>
                                                <td>0</td>
                                                <td>50</td>
                                                <td>Lorem</td>
                                                </tr>
                                            </tbody>
                                            </table>
                                        </div>
                                        <div class="o-emp-csv-download"><strong>- OR -</strong> Download sample <a href="static/assets/download/sample.csv" download class="o-csv-download"><i class="fa fa-download" aria-hidden="true"></i></a></div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <hr class="o-modal-separetor" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group ">
                                        <label class="common-label-text o-super-label">employee status:</label>
                                        <div class="o-custom-dropdown">
                                            <select class="form-control" v-model="selectedStatusId">
                                                    <option value="">Select</option>
                                                    <option v-for="status in employee_status" :value="status.id">{{status.name}}</option>

                                                </select>
                                            <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                        <button class="btn c-common-btn c-common-btn--small c-common-btn--green o-csv-upload">Choose File</button>
                                        <input class="" type="file" name="myfile" @change="uploadCSV($event)"/>
                                        <span>{{selectedCSV.name}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="text-right">
                                        <ul class="o-filter-area o-margin-bottom10">
                                            <li>
                                                <a href="javascript: void(0)" @click="backToList()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                            </li>
                                            <li>
                                                <a href="javascript: void(0)" @click="SaveEmployeeCSV()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
                <div class="col-sm-3 col-md-3">
                    <div class="grids c-common-box-shadow c-radius3 c-bg-white o-super-signin-area">
                        <div class="head">
                            <h3 class="o-super-title">Employee List:</h3>
                        </div>
                        <div class="body o-no-padding">
                            <div 
                                v-loading="loadingInactive" 
                                infinite-scroll-disabled="busy" 
                                infinite-scroll-distance="10" 
                                class="o-custom-table-container c-radius3 signin-list-table-align o-employee-listing"
                                v-infinite-scroll="{ handler: handleScroll, distance: 10 }"
                                ref="scrollContainer"
                                style="min-height: 1px;"
                            >
                                <div class="col-sm-12 o-no-padding">
                                    <ul class="o-employeeCsv-list">
                                        <li v-for="emp in inactiveEmployee" :key="emp.id">
                                            <div class="o-skill-box c-common-gradient c-common-box-shadow o-employeeList">
                                                <h3>
                                                    {{(emp.employable)? emp.employable.first_name+" "+emp.employable.last_name : ''}}
                                                </h3>
                                                <p><strong>Status:</strong> {{(emp.employee_status)?emp.employee_status.name:''}}</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';

    export default {
        data() {
            return {
               employee_status : [],
               selectedStatusId:'',
               selectedCSV:'',
               inactiveEmployee:[],
               next_page:'',
               storeMore:'',
               loading:false,
               loadingInactive:false,

            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                selectedClientId: 'selectedClientId',
                userRole: 'userRole',

            })
        },
        methods: {
            backToList() {
                this.$router.push({
                    'path': '/clientList'
                });
            },
            employeeStatusList()
            {
              service.get('employee/employee_status', {
                      'Authorization': this.userToken,
                      'cs3-context-role': this.userRole,
                      'cs3-context-clientId' : this.selectedClientId
                  })
                  .then((res) => {
                        this.employee_status = res.data.result;
                  }).catch((err) => {
                      console.log(err);
                  });
            },

            async handleScroll() {
                if (position !== "bottom") return; 
                await this.loadMore();
            },

            async loadMore() {
                if (this.storeMore.length != 0) {
                    var arr = this.inactiveEmployee;
                    this.storeMore.forEach(function(data) {
                        arr.push(data);
                    });
                    if (this.next_page != null) {
                        await service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.selectedClientId
                        })
                        .then((res) => {
                            this.storeMore = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;
                        }).catch((err) => {
                            console.log(err);
                        })
                    } else {
                        this.storeMore = [];
                    }
                }
                this.$nextTick(() => {
                    if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                        this.$refs.scrollContainer._checkScroll();
                    }
                });                
            },
            inactiveEmployeeList()
            { this.loadingInactive=true;
              service.get('employee/getInactiveEmployees', {
                      'Authorization': this.userToken,
                      'cs3-context-clientId' : this.selectedClientId
                  })
                  .then((res) => {
                      this.loadingInactive=false;
                       this.inactiveEmployee = res.data.result.data;
                       //console.log('inactive emp', this.inactiveEmployee);
                        this.next_page = res.data.result.next_page_url;
                       if (this.next_page != null) {
                            service.getUrl(this.next_page, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.selectedClientId
                            })
                            .then((res) => {
                                this.storeMore = res.data.result.data;
                                this.next_page = res.data.result.next_page_url;

                            }).catch((err) => {
                                console.log(err);

                            })
                        }
                  }).catch((err) => {
                      console.log(err);
                  });
            },
            uploadCSV(e) {
                //this.lockCSV = true;
                //  console.log('e.target.files', e.target.files[0]);
                var extension = e.target.files[0].name.split('.').pop();
                if(['xls', 'csv', 'xlsx', 'ods'].indexOf(extension) > -1){
                  var form = new FormData();
                  form.append("skillFile", e.target.files[0]);
                  this.selectedCSV=e.target.files[0];
                }else{
                  this.selectedCSV='';
                  this.$notify({
                      title: this.$t('error'),
                      message: 'Invalid file format. Please read the instruction before upload.',
                      type: 'error'
                  });
                }   
            },
            SaveEmployeeCSV(){
              var form = new FormData();
                form.append("client_id", this.selectedClientId);
                form.append("employeesCSV", this.selectedCSV);
                form.append("employee_status_id", this.selectedStatusId);
                this.loading=true;
                service.post('employee/importCSV', form, {
                        'Authorization': this.userToken,
                    })
                    .then((res) => {
                        this.loading=false;
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Employees Added Successfully.',
                            type: 'success'
                        });
                        this.$message({
                            type: 'success',
                            message: res.data.status_message 
                        });
                        //console.log(res.data.status_message,res);
                        this.inactiveEmployeeList();
                    }).catch((err) => {
                        console.log(err);
                        this.loading=false;
                        //this.lockCSV = false;
                        this.$notify({
                            title: this.$t('error'),
                            message: 'Invalid file format. Please read the instruction before upload.',
                            type: 'error'
                        });
                    })
            }

        },
        created() {
          this.employeeStatusList();
          this.inactiveEmployeeList();
             //console.log(this.selectedClientId);
        }
    }

</script>
